import type { ReceivingLabelPlanItem } from './flow'

export type LabelType = 'Pallet LPN' | 'Carton LPN' | 'Inner LPN'
export const labelTypes: LabelType[] = ['Pallet LPN', 'Carton LPN', 'Inner LPN']
export const labelTypeText = (type: LabelType) => (type === 'Inner LPN' ? 'Inner pack LPN' : type)
export const labelTypeFor = (level: ReceivingLabelPlanItem['level']): LabelType =>
  level === 'Carton' ? 'Carton LPN' : level === 'Inner pack' ? 'Inner LPN' : 'Pallet LPN'
export const planDescription = (item: ReceivingLabelPlanItem) => {
  const type = labelTypeFor(item.level)
  const fullness =
    item.level === 'Remainder pallet' || item.level === 'Partial receiving pallet' ? 'Partial pallet' : 'Full pallet'
  const method =
    item.level === 'Full pallet'
      ? 'Receive as a complete pallet'
      : 'Build by receiving child containers and any loose remainder eaches'
  return {
    type: labelTypeText(type),
    fullness: type === 'Pallet LPN' ? fullness : null,
    method: type === 'Pallet LPN' ? method : 'Receive individually onto a pallet',
  }
}

export interface PlannedLabel {
  lpn: string
  type: LabelType
  level: ReceivingLabelPlanItem['level']
  quantity: number
  sku: string
  /** Accepted print submission; physical output is acknowledged separately. */
  printed: boolean
  confirmed: boolean
  voided?: boolean
  actualQuantity?: number
  attributes?: { lot?: string; expiry?: string; manufactureDate?: string; bestBeforeDate?: string }
  contents?: PalletContents
}

export interface PalletContents {
  cartons: number
  cartonUnits: number
  inners: number
  innerUnits: number
  looseEaches: number
}

// Planned quantities, not physical parent/child associations. Actual nesting happens on scan.
export const planPalletContents = (quantity: number, cartonUnits: number, innerUnits: number): PalletContents => {
  const cartons = cartonUnits > 0 ? Math.floor(quantity / cartonUnits) : 0
  const remainder = quantity - cartons * cartonUnits
  const inners = innerUnits > 0 ? Math.floor(remainder / innerUnits) : 0
  return { cartons, cartonUnits, inners, innerUnits, looseEaches: remainder - inners * innerUnits }
}
export interface LabelPrintRequest {
  id: string
  printerId: string
  template: string
  lpns: string[]
  status: 'accepted' | 'rejected'
  attempts: number
  outputConfirmation?: 'declined' | 'confirmed'
  replacesRequestId?: string
  reason?: string
}

// Fixture printer destinations: no network/printer integration in this slice.
export const receivingPrinters = [
  { id: 'receiving-01', name: 'Receiving 01 — Zebra' },
  { id: 'receiving-02', name: 'Receiving 02 — Zebra' },
]
